<!-- @Author: Yu_Bo 2023-09-06 11:33:31-->
<template>
    <div>
        <el-table :data="list" v-loading="loading" style="width: 100%" key="model_list" header-cell-class-name="table-header" cell-class-name="cell-class">
            <template slot="empty">
                <empty-data img='no_img_b.png' text='暂无数据'></empty-data>
            </template>
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column prop="name" label="模特名称" width="100"></el-table-column>
            <el-table-column label="模特首张缩略图" width="140">
                <template slot-scope="scope">
                    <div class="scope_img">
                        <el-image style="width:35px; height: 35px" :src="scope.row.thumbnail" fit="scale-down" :preview-src-list="imgList"></el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="category_id_text" label="归属类型"></el-table-column>
            <el-table-column label="是否免费">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_free==1">是</span>
                    <span v-if="scope.row.is_free==2">否</span>
                </template>
            </el-table-column>
            <el-table-column label="是否会员">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_vip==1">是</span>
                    <span v-if="scope.row.is_vip==2">否</span>
                </template>
            </el-table-column>
            <el-table-column label="是否推荐">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_recom==1">是</span>
                    <span v-if="scope.row.is_recom==2">否</span>
                </template>
            </el-table-column>
            <el-table-column prop="hits" label="点击热度"></el-table-column>
            <el-table-column prop="price" label="钻石数"></el-table-column>
            <el-table-column prop="expire_day" label="使用期限(天)"></el-table-column>
            <el-table-column prop="give_minute" label="赠送分钟数"></el-table-column>
            <el-table-column label="上架状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" :active-value='1' :inactive-value='2' :key="scope.row.id" @change="changeSwitch($event,scope.row,scope.$index)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="170"></el-table-column>
            <el-table-column class-name="last_class" label="操作" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="editModel(scope.row.id)">编辑</el-button>
                    <el-button type="text" size="small" @click="delModel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="page_box" v-if="total" style="padding-bottom: 20px;">
            <paging-page :total='total' align='right' @sizeChange='sizeChangeBtn' @currentChange='currentChangeBtn'></paging-page>
        </div>
        <!-- 删除提示 -->
        <point-out ref='dialogTip' dialogTitle="提示" type="market" @close='closeModel' dialogWidth='420px' :iconShow='true' iconColor='#FF7432' borderRadius='10px' :cancelShow='true' :affirmShow='true'>
            <div class="zc_dialog_tip_content">
                <div class="text">确定要删除该模特吗？删除后将无法恢复</div>
            </div>
        </point-out>
    </div>
</template>

<script>
import PointOut from '@/components/point_out/point_out.vue'//提示
import EmptyData from '@/components/empty_data/empty_data.vue'//空数据
import PagingPage from '@/components/paging_page/paging_page.vue'//分页

export default {
    components: { PointOut, EmptyData, PagingPage },
    props: {},
    data() {
        return {
            formData: {
                name: "",
                gender: "",
                background_type: "",
                is_vip: "",
                category: "",
            },
            // 
            list: [],
            imgList: [],
            loading: false,
            //
            page: 1,
            limit: 10,
            total: 0,
            // 
            delId: null,
        };
    },

    computed: {},

    watch: {},

    created() { },

    mounted() {
        this.getList()
    },

    methods: {
        // 列表数据
        getList() {
            var that = this
            that.loading = true
            var params = {
                ...that.formData,
                page: that.page,
                limit: that.limit,
            }
            that.$marketApi.marketModel(params).then(res => {
                that.loading = false
                if (res.code == 1000) {
                    that.list = res.result.data || []
                    that.total = res.result.total || 0
                    that.list.forEach(ele => {
                        that.imgList.push(ele.thumbnail)
                    })
                } else {
                    that.$errMsg(res.message)
                }
            })
        },
        // 搜索
        search(info) {
            this.formData = info
            this.page = 1
            this.total = 0
            this.getList()
        },
        // 编辑
        editModel(val) {
            this.$router.push({
                path: '/market/model/add_edit',
                query: {
                    id: val
                }
            })
        },
        // 删除
        delModel(val) {
            this.delId = val
            this.$refs.dialogTip.openDialogBtn()
        },
        // 确定删除
        closeModel() {
            var that = this
            if (that.delId != null) {
                var params = {}
                that.$marketApi.delMarketModel(params, that.delId).then(res => {
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.delId = null
                        if (that.list.length == 1) {
                            that.search(that.formData)
                        } else {
                            that.getList()
                        }
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            }
        },
        // 改变每页条数
        sizeChangeBtn(val) {
            this.limit = val
            this.page = 1
            this.getList()
        },
        // 改变页数
        currentChangeBtn(val) {
            this.page = val
            this.getList()
        },
        // 修改状态
        changeSwitch(val, info, index) {
            var that = this
            var params = {
                id: info.id,
                status: val
            }
            that.$marketApi.marketModelStatus(params).then(res => {
                if (res.code == 1000) {
                    that.list[index].status = val
                    that.$succMsg(res.message)
                } else {
                    that.list[index].status = val == 1 ? 2 : 1
                    that.$errMsg(res.message)
                }
            })
        },
    }
}
</script>
<style lang='scss' scoped>
.scope_img {
    padding-right: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>